var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelecStarBgr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 269,
    viewBox: "0 0 354 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5922_48539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.224 264.728C346.836 266.623 347.117 269 347.117 269H6.936C6.936 269 7.14642 265.709 5.61902 264.497C4.09161 263.285 0 263.456 0 263.456V5.25702C0 5.25702 3.6702 5.36826 5.1976 4.15628C6.72501 2.94427 6.58734 0 6.58734 0H347.257C347.257 0 347.415 2.48248 348.943 3.69449C350.47 4.90646 354 5.25702 354 5.25702L354 263.456C354 263.456 351.612 262.833 349.224 264.728Z",
    fill: "#39346D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81519 268.121C7.8024 267.818 7.77515 267.461 7.72104 267.08C7.5787 266.077 7.21555 264.641 6.16568 263.808C5.64291 263.394 4.96274 263.139 4.31641 262.972C3.65543 262.801 2.94949 262.703 2.31519 262.646C1.77737 262.598 1.27737 262.579 0.879486 262.572V6.12671C1.23007 6.11343 1.66022 6.08691 2.12357 6.03519C2.7074 5.97006 3.36142 5.8631 3.98318 5.68509C4.59503 5.50992 5.23462 5.2496 5.74426 4.84521C6.77045 4.03094 7.16562 2.71631 7.33136 1.77637C7.38895 1.4498 7.42307 1.14328 7.44305 0.879486H346.496C346.54 1.10486 346.601 1.36542 346.684 1.64432C346.936 2.48694 347.426 3.61365 348.396 4.38342C349.331 5.12534 350.773 5.54816 351.853 5.78867C352.331 5.8952 352.772 5.97284 353.121 6.02692L353.121 262.48C352.913 262.476 352.68 262.483 352.428 262.506C351.393 262.6 350.028 262.967 348.677 264.039C347.318 265.118 346.698 266.355 346.427 267.342C346.348 267.627 346.299 267.89 346.27 268.121H7.81519Z",
    stroke: "#B89B73",
    strokeWidth: 1.75896
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5922_48539",
    x: -8.79482,
    y: -8.79482,
    width: 371.59,
    height: 286.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.39741
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5922_48539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5922_48539",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelecStarBgr);
export default __webpack_public_path__ + "static/media/selecStarBgr.0a5b6ac430831467c5f172f3cb396ed8.svg";
export { ForwardRef as ReactComponent };